import { Alert } from '@mui/material';
import { useEffect, useRef } from 'react';
import { FieldErrors } from '../utils/form-feedback';

export default function FormFeedback({ message, errors = {} }: { message: string; errors?: FieldErrors }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (message) {
      ref.current?.focus();
      ref.current?.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
    }
  }, [message]);
  return message ? (
    <Alert ref={ref} tabIndex={-1} severity="error" sx={{ my: 2, maxWidth: 600 }}>
      {message}
      {!!Object.keys(errors).length && (
        <ul style={{ marginBottom: 0 }}>
          {Object.entries(errors).map(([field, error]) => (
            <li key={field}>{error}</li>
          ))}
        </ul>
      )}
    </Alert>
  ) : null;
}
